<template>
  <div>
    <TplListBasic :title="title(routeName)" :bgcolorClass="bgClass(routeName)">
      <template v-slot:actions>
        <div class="actions-btns-container">
          <div class="actions-btns-container">
            <el-button type="primary" class="btn" @click="handleSubmit">Submit</el-button>
            <el-button class="btn" @click="handleCancel">Cancel</el-button>
            <!-- <el-button class="btn" type="danger" plain>Void</el-button> -->
            <!-- <btn-print></btn-print>
            <btn-edit></btn-edit>-->
            <!-- <el-button class="btn" type="primary">Approve</el-button>
            <el-button class="btn" type="primary">UnApprove</el-button>
            <el-button class="btn" type="primary">Close</el-button>-->
          </div>
        </div>
      </template>
      <template v-slot:search>
        <OrderInputs :isEdit="true" :config="config" />
      </template>
      <template v-slot:results>
        <OrderLinesEdit :isEdit="true" :config="lineConfig" />
      </template>
    </TplListBasic>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import TplListBasic from '../components/TplListBasic'
import OrderInputs from '../components/OrderInputs'
import OrderLinesEdit from '../components/OrderLinesEdit'

export default {
  name: 'OrderAdd',
  components: {
    TplListBasic,
    OrderInputs,
    OrderLinesEdit
    // CartSimple
  },
  created () {
    this.routeName = this.$route.params.routeName
    const isClone = this.$route.params.operation === 'clone'
    const isCloneBillToInv = this.$route.params.operation === 'cloneBillToInv'
    const isAddFromCart = this.$route.params.operation === 'addFromCart'
    const isAddFromCartAndClear =
      this.$route.params.operation === 'addFromCartAndClear'
    const id = this.$route.params.id || 0

    if (isClone) {
      this.clone(this.routeName)
    } else if (isAddFromCart) {
      this.addFromCart()
    } else if (isAddFromCartAndClear) {
      this.addFromCart(true)
    } else if (isCloneBillToInv) {
      this.cloneBillToInv(this.routeName)
    } else {
      if (id > 0) {
        this.initEdit({ routeName: this.routeName, id })
      } else {
        this.initAdd(this.routeName).then(() => this.addNewLine())
      }
    }
  },
  data () {
    return {
      // bus: new Vue(),
      routeName: ''
    }
  },
  computed: {
    ...mapState('config', {
      config: 'inputs',
      lineConfig: 'lines'
    }),
    ...mapState('edit', {
      csr: 'csr',
      lines: 'lines'
    }),
    ...mapGetters({
      bgClass: 'prefs/searchBgClass',
      title: 'prefs/getPageTitle'
    })
  },
  methods: {
    ...mapMutations({
      addNewLine: 'edit/newLine',
      setAllLinesPrices: 'edit/setAllLinesPrices'
    }),
    ...mapActions({
      initAdd: 'edit/initAdd',
      initEdit: 'edit/initEdit',
      clone: 'edit/cloneTo',
      cloneBillToInv: 'edit/cloneBillToInv',
      addFromCart: 'edit/initAddFromCart',
      create: 'edit/create'
    }),
    handleSubmit () {
      this.create().then(data => {
        this.success(data.id)
      })
    },
    success (id) {
      this.$message({
        message: 'Operation successful',
        type: 'success'
      })
      this.$router.push({
        name: 'OrderDetail',
        params: { routeName: this.routeName, id }
      })
    },
    handleCancel () {
      this.$router.back()
    }
  },
  beforeRouteUpdate (to, from, next) {
    // just use `this`
    this.routeName = to.params.routeName
    next()
  },

  provide () {
    return {
      // bus: this.bus,
      routeName: this.routeName
    }
  },
  watch: {
    // 检查state里面csr的变化，用于修改行项目的单价，姚爷看看，不知道写在这个组件层面对不对？
    csr: function (newCSR, oldCSR) {
      // if (newCSR.id) {
      //   this.setAllLinesPrices()
      // }
      if (oldCSR.id) {
        // 第一行有货品且不是首次填入客户，那么弹框提示用户更改csr导致货品价格自动修改
        if (this.lines && this.lines.length > 0 && this.lines[0].product.name) {
          this.$message({
            dangerouslyUseHTMLString: true,
            message:
              '<strong>CSR </strong>changed, mind items <strong>PRICE & QTY</strong>',
            center: true
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-area {
  background-color: #fff;
}
.list {
  margin-top: 40px;
  background-color: #ffffff;
}
.btn {
  height: 32px;
  margin-left: 12px;
  padding: 0 16px;
  line-height: 32px;
}
.actions-btns-container {
  display: flex;
  margin-right: 12px;
}

.page-wrapper {
  max-width: 1678px;
}
.viewpage-caption-container {
  display: flex;
  justify-content: space-between;
  height: 32px;
  line-height: 32px;
  margin-bottom: 12px;
}
.title {
  text-align: left;
  font-size: 18px;
  color: #939393;
  text-indent: 8px;
  font-weight: bold;
}
.search-area {
  margin-bottom: 8px;
}
.creditBgColor {
  background-color: #f9f5ec;
}
.pOrderBgColor {
  background-color: #ebf3ebda;
}
</style>
